import {useTranslation} from 'react-i18next';
import {useClientsContext} from '../../../context/clients/ClientsContextProvider';

function FormsHeader() {
  const {t} = useTranslation();
  const {selectedLocation} = useClientsContext();

  return (
    <div className="w-full bg-white px-4 py-4 shadow-md z-[2]">
      <div className="w-full h-full flex items-center">
        <div className="flex items-center gap-2 min-w-[400px]">
          {/* Main title */}
          <span className="text-2xl font-semibold leading-6 text-black">
            {t('forms.pageTitle')}
          </span>

          {/* Separator */}
          <span className="text-2xl leading-6 text-deepAqua">&gt;</span>

          {/* Selected location */}
          <span className="text-2xl font-semibold leading-6 text-deepAqua">
            {selectedLocation?.name ?? ''}
          </span>
        </div>
      </div>
    </div>
  );
}

export default FormsHeader;
